<template>
  <div class="workbench-approval">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="approval-main">
      <!-- <el-collapse v-model="collapseActiveName" accordion>
        <el-collapse-item name="1"> -->
      <!-- <template slot="title">
            <el-badge :value="pendingApprovalTotal" class="item"><i class="el-icon-damai-hetong"></i>合同审批123</el-badge>
          </template> -->
      <div>
        <el-tabs v-model="steamActiveName" type="card">
          <el-tab-pane label="待我审批" name="steamPendingApproval">
            <table-main :tableHeight="520" :selection="false" :tableHead="steamPendingApprovalTableHead" @seeExample="seeExample" :tableData="steamPendingApprovalTableData" :operationArr="steamPendingApprovalOperationArr" @electricApproveRow="steamApproveRow" @electricUnApproveRow="steamUnApproveRow" :total="steamPendingApprovalTotal" :pageNum="steamPendingApprovalPageNum" :pageSize="steamPendingApprovalPageSize" @changePagination="changeSteamPendingApprovalPagination" />
          </el-tab-pane>
          <el-tab-pane label="我已审批" name="steamApproved">
            <table-main :tableHeight="520" :selection="false" :tableHead="steamApprovedTableHead" @seeExample="seeExample" :tableData="steamApprovedTableData" :operationArr="steamApprovedOperationArr" @toDetailsPage="toDetailsPage" :total="steamApprovedTotal" :pageNum="steamApprovedPageNum" :pageSize="steamApprovedPageSize" :hasOperation="false" @changePagination="changeSteamApprovedPagination" />
          </el-tab-pane>
          <el-tab-pane label="我发起的" name="steamSponsored">
            <table-main :tableHeight="520" :selection="false" :tableHead="steamSponsoredTableHead" @seeExample="seeExample" :tableData="steamSponsoredTableData" :operationArr="steamSponsoredOperationArr" @toDetailsPage="toDetailsPage" :total="steamSponsoredTotal" :pageNum="steamSponsoredPageNum" :pageSize="steamSponsoredPageSize" :hasOperation="false" @changePagination="changeSteamSponsoredPagination" />
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- </el-collapse-item>
      </el-collapse> -->
    </div>
    <!--蒸汽-->
    <div class="approveDialogBox">
      <el-dialog title="同意意见" :visible.sync="steamApproveDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">同意意见</div>
            <el-input type="textarea" :rows="4" placeholder="同意意见" v-model="steamApproveMemo" style="width: 300px" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="steamCancelApprove">取 消</el-button>
          <el-button size="small" type="primary" @click="steamPassSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="approveDialogBox">
      <el-dialog title="驳回意见" :visible.sync="steamApproveRejectDialog">
        <div class="approveMainBox">
          <div class="approveFlexBox">
            <div class="approve_title">驳回意见</div>
            <el-input type="textarea" :rows="4" placeholder="驳回意见" v-model="steamRejectMemo" style="width: 300px" size="mini" />
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="steamCancelReject">取 消</el-button>
          <el-button size="small" type="primary" @click="steamUnpassSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <el-dialog title="审批进度" :visible.sync="flowDialog" style="margin-top:200px">
      <el-steps :active="currentRate" align-center finish-status="success">
        <el-step :title="applyData.status=='4'?applyData.sponsorAccountName+'已撤回':applyData.sponsorAccountName+'发起审批'" :description="applyData.sponsorDate"></el-step>
        <el-step v-if="applyData.status!='4'" v-for="(item, index) in flowData" :key="item.code" :title="item.statusText" :description="item.approveDate" :status="item.status&&item.status!='1'?item.status=='3' ? 'error' : 'success':''"></el-step>
      </el-steps>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TableMain from '../../../components/Table/TableMain'
import { errorHandler } from '../../../utils/errorHandler'
import { nSuccess } from '../../../utils/notice'
import { bus } from '../../../utils/bus'
import { api } from '../../api/WorkbenchApproval'

export default {
  components: {
    TableMain,
    Breadcrumb,
  },
  name: 'workbench-approval',
  data() {
    return {
      yqCode: '',
      breadcrumb: [
        {
          value: '待办事项',
          name: 'contract-approval',
        },
        {
          value: '蒸汽充值审批',
        },
      ],
      collapseActiveName: '',
      steamCollapseItemTitle: '蒸汽充值审批',
      accountCode: '',
      steamActiveName: 'steamPendingApproval',

      // 我发起的(蒸汽)
      steamSponsoredTableHead: [
        // {
        //   prop: 'indexProgress',
        //   label: '审批进度',
        // },
        {
          prop: 'sponsorAccountName',
          label: '提交人',
        },
        {
          prop: 'digest',
          label: '摘要',
        },
        {
          prop: 'sponsorDate',
          label: '发起时间',
        },
        {
          prop: 'workState',
          label: '状态',
          showColor: true,
        },
        {
          prop: 'memo',
          label: '审批意见',
        },
        {
          prop: 'approveAccountName',
          label: '处理人',
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      steamSponsoredTableData: [],
      steamSponsoredOperationArr: ['details'],
      steamSponsoredTotal: 0,
      steamSponsoredPageNum: 1,
      steamSponsoredPageSize: 10,

      // 待我审批(蒸汽)
      steamPendingApprovalTableHead: [
        {
          prop: 'sponsorAccountName',
          label: '提交人',
        },
        {
          prop: 'digest',
          label: '摘要',
        },
        {
          prop: 'sponsorDate',
          label: '发起时间',
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      steamPendingApprovalTableData: [],
      steamPendingApprovalOperationArr: ['electricApproveRow', 'electricUnApproveRow'],
      steamPendingApprovalTotal: 0,
      steamPendingApprovalPageNum: 1,
      steamPendingApprovalPageSize: 10,

      // 我已审批(蒸汽)
      steamApprovedTableHead: [
        {
          prop: 'sponsorAccountName',
          label: '提交人',
        },
        {
          prop: 'digest',
          label: '摘要',
        },
        {
          prop: 'sponsorDate',
          label: '发起时间',
        },
        {
          prop: 'approveDate',
          label: '审批时间',
        },
        {
          prop: 'workState',
          label: '状态',
          showColor: true,
        },
        {
          prop: 'memo',
          label: '审批意见',
        },
        {
          prop: "payChannelText",
          label: "审批进度",
          example: true
        },
      ],
      steamApprovedTableData: [],
      steamApprovedOperationArr: ['details'],
      steamApprovedTotal: 0,
      steamApprovedPageNum: 1,
      steamApprovedPageSize: 10,

      steamApproveData: {},
      steamUnApproveData: {},
      steamApproveDialog: false,
      steamApproveMemo: '',
      steamApproveRejectDialog: false,
      steamRejectMemo: '',

      operationArr: ['modifySuggestions'],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      requestData: {
        responsiblePersonCode: '',
        searchKey: '',
        result: '',
        status: '0',
      },
      flowDialog:false,
      applyData:{},
      chainList:[],
      flowData:{},
      currentRate:0
    }
  },
  created() {
    this.yqCode = bus.global.yqCode
    this.requestData.responsiblePersonCode = bus.global.accountCode
    this.accountCode = bus.global.accountCode
    this.getPageBySteamPendingApprovalPage()
  },
  mounted() {
    if (this.$route.params.workType) {
      this.activeName = this.$route.params.workType
    }
  },
  methods: {
    // 跳转审批详情页面
    toDetailsPage(data) {
      sessionStorage.setItem('workDetailData', JSON.stringify(data))
      sessionStorage.setItem('workDetailActiveName', this.activeName)
      if (data.type === '其他合同') {
        this.$router.push({
          name: 'other-approval-detail',
        })
      } else {
        this.$router.push({
          name: 'approval-detail',
        })
      }
    },

    // 我发起的页码跳转(蒸汽)
    changeSteamSponsoredPagination(data) {
      this.steamSponsoredPageNum = data[0]
      this.steamSponsoredPageSize = data[1]
      this.getPageBySteamSponsorAccountCode()
    },

    // 待我审批页码跳转(蒸汽)
    changeSteamPendingApprovalPagination(data) {
      this.steamPendingApprovalPageNum = data[0]
      this.steamPendingApprovalPageSize = data[1]
      this.getPageBySteamPendingApprovalPage()
    },

    // 我已审批页码跳转(蒸汽)
    changeSteamApprovedPagination(data) {
      this.steamApprovedPageNum = data[0]
      this.steamApprovedPageSize = data[1]
      this.getPageBySteamApprovedPage()
    },

    // 我发起的(蒸汽)
    getPageBySteamSponsorAccountCode() {
      let reqData = {}
      reqData.pageNum = this.steamSponsoredPageNum
      reqData.pageSize = this.steamSponsoredPageSize
      reqData.sponsorAccountCode = this.accountCode
      this.$axios
        .post(api.getSteamApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map((v) => {
              if (v.index === 1) {
                v.indexProgress = '1级审批'
              } else if (v.index === 2) {
                v.indexProgress = '2级审批'
              } else if (v.index === 3) {
                v.indexProgress = '3级审批'
              }
              if (v.status === '1') {
                v.workState = '审批中'
                v.fontColorToPeople = '#FF9933'
              } else if (v.status === '2') {
                v.workState = '审批通过'
                v.fontColorToPeople = '#00A0E6'
              } else if (v.status === '3') {
                v.workState = '审批驳回'
                v.fontColorToPeople = '#B22222'
              }
            })
            this.steamSponsoredTotal = res.data.data.total
            this.steamSponsoredTableData = data
          }
        })
        .catch(errorHandler('获取数据失败'))
    },

    // 待我审批(蒸汽)
    getPageBySteamPendingApprovalPage() {
      let reqData = {}
      reqData.pageNum = this.steamPendingApprovalPageNum
      reqData.pageSize = this.steamPendingApprovalPageSize
      reqData.approveAccountCode = this.accountCode
      reqData.status = '1'
      this.$axios
        .post(api.getSteamApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map((v) => {
              if (v.index === 1) {
                v.indexProgress = '1级审批'
              } else if (v.index === 2) {
                v.indexProgress = '2级审批'
              } else if (v.index === 3) {
                v.indexProgress = '3级审批'
              }
              if (v.status === '1') {
                v.workState = '审批中'
                v.fontColorToPeople = '#FF9933'
              } else if (v.status === '2') {
                v.workState = '审批通过'
                v.fontColorToPeople = '#00A0E6'
              } else if (v.status === '3') {
                v.workState = '审批驳回'
                v.fontColorToPeople = '#B22222'
              }
            })
            this.steamPendingApprovalTotal = res.data.data.total
            this.steamPendingApprovalTableData = data
          }
        })
        .catch(errorHandler('获取数据失败'))
    },

    // 我已审批(蒸汽)
    getPageBySteamApprovedPage() {
      let reqData = {}
      reqData.pageNum = this.steamApprovedPageNum
      reqData.pageSize = this.steamApprovedPageSize
      reqData.approveAccountCode = this.accountCode
      reqData.status = '2,3'
      this.$axios
        .post(api.getSteamApprovePage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map((v) => {
              if (v.status === '1') {
                v.workState = '审批中'
                v.fontColorToPeople = '#FF9933'
              } else if (v.status === '2') {
                v.workState = '审批通过'
                v.fontColorToPeople = '#00A0E6'
              } else if (v.status === '3') {
                v.workState = '审批驳回'
                v.fontColorToPeople = '#B22222'
              }
            })
            this.steamApprovedTotal = res.data.data.total
            this.steamApprovedTableData = data
          }
        })
        .catch(errorHandler('获取数据失败'))
    },

    // 蒸汽审批通过
    steamApproveRow(data) {
      for (let i in data) {
        if (data[i] === '--') {
          data[i] = ''
        }
      }
      this.steamApproveData = data
      this.steamApproveDialog = true
    },
    // 蒸汽审批驳回
    steamUnApproveRow(data) {
      for (let i in data) {
        if (data[i] === '--') {
          data[i] = ''
        }
      }
      this.steamUnApproveData = data
      this.steamApproveRejectDialog = true
    },

    // 取消通过
    cancelApprove() {
      this.approveMemo = ''
      this.approveDialog = false
    },

    // 确认通过
    passSubmit() {
      this.electricApproveData.memo = this.approveMemo
      this.$axios
        .post(api.passElectricApprove, this.electricApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.approveMemo = ''
            this.approveDialog = false
            nSuccess('审批已通过')
            this.getPageByElectricPendingApprovalPage()
          }
        })
        .catch(errorHandler('通过失败'))
    },

    // 取消驳回
    cancelReject() {
      this.rejectMemo = ''
      this.approveRejectDialog = false
    },

    // 确认驳回
    unpassSubmit() {
      this.electricUnApproveData.memo = this.rejectMemo
      this.$axios
        .post(api.unPassElectricApprove, this.electricUnApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.rejectMemo = ''
            this.approveRejectDialog = false
            nSuccess('审批已驳回')
            this.getPageByElectricPendingApprovalPage()
          }
        })
        .catch(errorHandler('驳回失败'))
    },

    // 取消通过(蒸汽)
    steamCancelApprove() {
      this.steamApproveMemo = ''
      this.steamApproveDialog = false
    },

    // 确认通过(蒸汽)
    steamPassSubmit() {
      this.steamApproveData.memo = this.steamApproveMemo
      this.$axios
        .post(api.passSteamApprove, this.steamApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.steamApproveMemo = ''
            this.steamApproveDialog = false
            nSuccess('审批已通过')
            this.getPageBySteamPendingApprovalPage()
          }
        })
        .catch(errorHandler('通过失败'))
    },

    // 取消驳回(蒸汽)
    steamCancelReject() {
      this.steamRejectMemo = ''
      this.steamApproveRejectDialog = false
    },

    // 确认驳回(蒸汽)
    steamUnpassSubmit() {
      this.steamUnApproveData.memo = this.steamRejectMemo
      this.$axios
        .post(api.unPassSteamApprove, this.steamUnApproveData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.steamRejectMemo = ''
            this.steamApproveRejectDialog = false
            nSuccess('审批已驳回')
            this.getPageBySteamPendingApprovalPage()
          }
        })
        .catch(errorHandler('驳回失败'))
    },
    seeExample(data){
      this.$axios.post(api.getSteamApproveFlow, {outTradeNo: data.outTradeNo}).then(res=>{
        this.applyData=res.data.data.apply
        this.chainList=res.data.data.chainList
        this.flowData=res.data.data.flow.flowDetails
        if(this.applyData.status && this.applyData.status=='4'){
          this.flowDialog=true;
          this.currentRate=0
          return;
        }
        this.flowData.map(u=>{
          u.statusText=u.accountName
          this.chainList.map(v=>{
            if(v.approveAccountCode==u.accountCode){
              u.approveDate=v.approveDate
              u.status=v.status
              if(v.status=='2'){
                u.statusText=u.accountName+'已通过'
              } else if(v.status=='3'){
                u.statusText=u.accountName+'已驳回'
              }
            }
          })
        })
        this.flowData.map(v=>{
          let accountCode = v.accountCode;
          this.chainList.map(u=>{
            if(accountCode == u.approveAccountCode){
              if(u.status=='1'){
                this.currentRate =+ u.index;
              }else{
                this.currentRate =+ u.index+1;
              }
            }
          })
        })
        // this.flowData.map(v=>{
        //   if(v.accountCode==this.chainList[0].sponsorAccountCode){
        //     if(this.chainList[0].status=='1'){
        //       this.currentRate=+this.chainList[0].index
        //     }else{
        //       this.currentRate=+this.chainList[0].index+1
        //     }
        //   }
        // })
        this.flowDialog=true
      }).catch(errorHandler("获取审批进度失败"))
    }
  },
  watch: {
    steamActiveName(val) {
      if (val === 'steamSponsored') {
        this.steamSponsoredPageNum = 1
        this.steamSponsoredPageSize = 10
        this.getPageBySteamSponsorAccountCode()
      } else if (val === 'steamPendingApproval') {
        this.steamPendingApprovalPageNum = 1
        this.steamPendingApprovalPageSize = 10
        this.getPageBySteamPendingApprovalPage()
      } else if (val === 'steamApproved') {
        this.steamApprovedPageNum = 1
        this.steamApprovedPageSize = 10
        this.getPageBySteamApprovedPage()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.workbench-approval {
  /deep/ .el-collapse-item__header {
    height: 60px;
    line-height: 60px;
  }
  .item {
    font-size: 16px;
    line-height: 28px;
    margin-right: 29px;
    .el-badge__content.is-fixed {
      top: 2px;
      right: 5px;
    }
    i {
      width: 40px;
      font-size: 18px;
      color: #00a0e6;
      margin-right: 5px;
    }
  }
  .breadcrumb-box {
    border-bottom: 0 !important;
  }
  .el-tabs__active-bar {
    width: 96px !important;
  }
  .el-tabs--top {
    height: 100%;
    .is-top:nth-child(2) {
      /*padding-left: 20px!important;*/
      padding: 0 20px 0 0;
    }
    #tab-pendingApproval {
      /*margin: 0 20px 0 0;*/
    }
    .is-top:last-child {
      /*padding-left: 0;*/
    }
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }

  .approval-main {
    height: 96%;
    /*padding: 10px 10px 0 10px;*/
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    h4 {
      border-left: 3px solid #00a0e6;
      padding-left: 5px;
      font-size: 16px;
      line-height: 16px;
      font-weight: 400;
      text-align: left;
    }
    .approval-main-top {
      height: 45%;
      .all-table-class .el-table td {
        padding: 3px 0;
      }
    }
    .approval-main-bottom {
      height: 45%;
      .all-table-class .el-table td {
        padding: 8px 0;
      }
    }
    .el-tabs__content {
      padding-bottom: 20px;
      height: 100%;
    }
  }

  .approveDialogBox {
    text-align: left;
    .el-dialog {
      width: 800px;
    }
    .approveMainBox {
      text-align: center;
    }
    .approve_title {
      width: 120px;
    }
    .approveFlexBox {
      width: 500px;
      margin: 0 auto 20px;
      display: flex;
      justify-content: flex-start;
    }
    .red {
      color: red;
    }
  }
  /deep/ .el-tabs__item.is-active {
    background-color: #1362ff;
    color: #fff;
    border-radius: 3px;
  }
  /deep/ .breadcrumb-box {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header {
    border-bottom: none;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__nav {
    border-bottom: 1px solid #e4e7ed !important;
  }
  /deep/.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #1362ff;
  }
}
/deep/ .el-step__description {
  margin-top: -8em ;
}
/deep/ .el-dialog__body{
  padding:50px 0 ;
  color: #1362FF ;
}
/deep/.el-step__head.is-success{
  color: #1362FF ;
  border-color: #1362FF ;
}
/deep/.el-step__title.is-success{
  color: #1362FF ;
}
/deep/.el-step__description.is-success{
  color:#1362FF ;
}
</style>



// WEBPACK FOOTER //
// src/view/PendingItems/SteamApproval/SteamApproval.vue